module.exports = __webpack_public_path__ + "static/Julie2-428937ca8a0adc2b5ff82c5d3e9b22d5.jpg";